import { SimpleFooter, SkipNav } from '@cmsgov/ds-medicare-gov';
import { useFlags } from 'launchdarkly-react-client-sdk';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import './App.css';
import SiteHeader from './common/components/site.header';
import consoleLogVersion from './common/functions/console.log.version';
import setLanguage from './common/functions/set.language';
import translate from './common/functions/translate';
import useLoadSharedHooks from './common/hooks/use.load.shared.hooks';
import CreateAccount from './create-account/components/create.account';
import FindMyAccount from './find-my-account/components/find.my.account';
import ForgotPassword from './forgot-password/components/forgot.password';
import ForgotUsernameAndPassword from './forgot-username-and-password/components/forgot.username.and.password';
import ForgotUsername from './forgot-username/components/forgot.username';
import Login from './login/components/login';
import UnlockAccount from './unlock-account/components/unlock.account';
import { redirectFromSpanishSite } from './common/functions/redirect.from.spanish.site';
import { loadGlobalHeader } from './common/functions/load.global.header';

const GlobalHeader = ({liveChat}) => {
   useEffect(() => {
      loadGlobalHeader(liveChat);
   }, [liveChat]);
   
   return null;
};

export default function App() {
   redirectFromSpanishSite();
   useLoadSharedHooks();
   setLanguage();
   const location = useLocation();
   const {globalHeader, globalHeaderLiveChat} = useFlags();
   
   useEffect(() => {
      consoleLogVersion();
   }, []);
   
   return <>
      <SkipNav href="#main">
         {translate('Skip to main content')}
      </SkipNav>
      {globalHeader ?
         <GlobalHeader liveChat={globalHeaderLiveChat}/> :
         <SiteHeader/>
      }
      <main id="main">
         <div
            className={'ds-base'}
            id={'App'}
            style={{minHeight: 600}}
         >
            <Switch location={location}>
               <Route
                  exact={true}
                  path={'/'}
               >
                  <Redirect to={'/login'}/>
               </Route>
               <Route
                  component={CreateAccount}
                  exact={true}
                  path={'/create-account'}
               />
               <Route
                  component={FindMyAccount}
                  path={'/find-my-account'}
               />
               <Route
                  component={ForgotPassword}
                  exact={true}
                  path={'/forgot-password'}
               />
               <Route
                  component={ForgotUsername}
                  exact={true}
                  path={'/forgot-username'}
               />
               <Route
                  component={ForgotUsernameAndPassword}
                  exact={true}
                  path={'/forgot-username-and-password'}
               />
               <Route
                  component={Login}
                  path={'/login'}
               />
               <Route
                  component={UnlockAccount}
                  path={'/unlock-account'}
               />
               <Route>
                  <Redirect to={'/login'}/>
               </Route>
            </Switch>
         </div>
      </main>
      <SimpleFooter
         aboutMedicareLabel={translate('About Medicare')}
         linkingPolicyLabel={translate('Linking Policy')}
         medicareGlossaryLabel={translate('Medicare Glossary')}
         nondiscriminationLabel={translate('Nondiscrimination/Accessibility')}
         plainWritingLabel={translate('Plain Writing')}
         privacyPolicyLabel={translate('Privacy Policy')}
         privacySettingLabel={translate('Privacy Setting')}
         usingThisSiteLabel={translate('Using this site')}
         websiteInfo={translate('A federal government website managed and paid for by the U.S. Centers for Medicare and Medicaid Services.')}
      />
   </>
};
